import React, { useRef } from 'react';
import { useState } from 'react'

import { serviceResolver } from '@infonova/framework/lib/service/configuration/serviceResolver';

import Button from '../button/button';
import { ExternalServiceConfiguration } from "../../configuration/ExternalServiceConfiguration";


type DraftOrderComponentProps = {
    createDraftUrl: string,
    accountId: string,
    customerAccountId: string,
    opportunityId: string,
    quoteId: string,
    callback: (evt: any) => void
};

const DraftOrderComponent = (props: DraftOrderComponentProps) => {

    const salesforceService = serviceResolver().getService(ExternalServiceConfiguration.SalesforceService);
    const integrationService = serviceResolver().getService(ExternalServiceConfiguration.IntegrationService);


    const createOffer = async () => {
        salesforceService.sendSalesforceMessage({
            name: "DataChange", value: {
                "type": "DraftOrderCreating"
            }
        });

        const draftResponse = integrationService.createDraft(props.createDraftUrl, {
            accountId: props.accountId,
            customerAccountId: props.customerAccountId,
            opportunityId: props.opportunityId,
            quoteId: props.quoteId
        });

        props.callback(await draftResponse);
    };


    {/* @ts-ignore */ }
    return <div>
        <Button onClick={createOffer} className='btn btn--oval btn--colored btn--small'>Configure Quote</Button>
    </div>
};

export { DraftOrderComponent };
